import React from 'react';
import PropTypes from 'prop-types';

import PopupV2 from '../Popup/PopupV2';
import Img from '../Img';
import useIsMobile from '../hooks/useIsMobile';

export const MODAL_TITLE = 'Tennis Australia (TA) Tennis ID';
export const MODAL_BODY_INTRO = 'To register for this event, you\'ll need a Tennis Australia (TA) Tennis ID.';
export const MODAL_BODY_OPTIONS = [
    { id: 'existing-account', lead: 'Already have one?', text: 'Click Continue and sign in.' },
    { id: 'new-account', lead: 'New to Tennis Australia?', text: 'Click Continue and sign up for your free Tennis account.' },
];
export const MODAL_BODY_OUTRO = 'You\'ll be returned here automatically to complete your event registration.';
export const CONTINUE_LABEL = 'Continue';
export const CANCEL_LABEL = 'Cancel';

const TA_LOGO_SRC = '/img/social/tennis-australia-logo.svg';
const TA_LOGO_ALT = 'Tennis Australia';

const TennisAustraliaIdModal = ({ onClose, onContinue, 'data-testid': dataTestId }) => {
    const { isMobileWidth } = useIsMobile();

    const renderHeader = () => {
        if (!isMobileWidth) {
            return null;
        }
        return (
            <div className="d-flex justify-content-end p16">
                <button
                    type="button"
                    className="btn btn-link p0 text-black"
                    onClick={onClose}
                    aria-label="Close"
                    data-testid={dataTestId && `${dataTestId}.close-btn`}
                >
                    <i className="utr utr-close" />
                </button>
            </div>
        );
    };

    return (
        <PopupV2
            onCloseClick={onClose}
            config={{
                size: 'medium',
                customHeader: renderHeader,
            }}
        >
            <div
                className="text-center"
                data-testid={dataTestId && `${dataTestId}.container`}
            >
                <div
                    className="fs16 fw600 mb24"
                    data-testid={dataTestId && `${dataTestId}.title`}
                >
                    {MODAL_TITLE}
                </div>
                <Img
                    src={TA_LOGO_SRC}
                    alt={TA_LOGO_ALT}
                    className="mb16"
                    style={{ width: '134px' }}
                    data-testid={dataTestId && `${dataTestId}.logo`}
                />
                <p
                    className="fs14 text-left mb16"
                    data-testid={dataTestId && `${dataTestId}.body-intro`}
                >
                    {MODAL_BODY_INTRO}
                </p>
                <ul
                    className="fs14 text-left pl24 mb16"
                    data-testid={dataTestId && `${dataTestId}.body-options`}
                >
                    {MODAL_BODY_OPTIONS.map((option) => (
                        <li
                            key={option.id}
                            data-testid={dataTestId && `${dataTestId}.body-option-${option.id}`}
                        >
                            <strong data-testid={dataTestId && `${dataTestId}.body-option-${option.id}.lead`}>
                                {option.lead}
                            </strong>
                            {' '}
                            {option.text}
                        </li>
                    ))}
                </ul>
                <p
                    className="fs14 text-left mb24"
                    data-testid={dataTestId && `${dataTestId}.body-outro`}
                >
                    {MODAL_BODY_OUTRO}
                </p>
                <div
                    className="d-flex justify-content-center"
                    data-testid={dataTestId && `${dataTestId}.actions`}
                >
                    {!isMobileWidth && (
                        <button
                            type="button"
                            className="btn btn-default btn-lg text-uppercase mr8"
                            onClick={onClose}
                            data-testid={dataTestId && `${dataTestId}.cancel-btn`}
                        >
                            {CANCEL_LABEL}
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-primary btn-lg text-uppercase"
                        onClick={onContinue}
                        data-testid={dataTestId && `${dataTestId}.continue-btn`}
                    >
                        {CONTINUE_LABEL}
                    </button>
                </div>
            </div>
        </PopupV2>
    );
};

TennisAustraliaIdModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};

TennisAustraliaIdModal.defaultProps = {
    'data-testid': null,
};

export default TennisAustraliaIdModal;
